import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider, } from "react-router-dom"
import { QueryClientProvider, QueryClient } from "@tanstack/react-query"
import router from './router'
import "./index.css";
import { ToastContainer } from "./components/Toast";

const queryClient = new QueryClient()

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <ToastContainer />
    </QueryClientProvider>
  </StrictMode>,
);
